import type { RelatorioVisitaMarcador } from '../../schemas/payload.schema';

const CORES_POR_SITUACAO: Record<string, string> = {
  '': 'verde',
  equilibrio: 'verde',
  alto_equilibrio: 'azul',
  controle: 'amarelo',
  alerta: 'vermelho',
  emergencia: 'vermelho',
  extremo: 'roxo',
  neutro: 'branco',
};

type ContextoWebpack = {
  keys: () => string[];
  (id: string): string | { default: string };
};

const NOMES_ICONES_TESTE = [
  'icon_anotacao_branco.png',
  'icon_aplicacao_afericao_branco.png',
  'icon_aplicacao_amarelo.png',
  'icon_aplicacao_branco.png',
  'icon_aplicacao_verde.png',
  'icon_aplicacao_vermelho.png',
  'icon_aspecto_geral_branco.png',
  'icon_climatica_amarelo.png',
  'icon_climatica_verde.png',
  'icon_climatica_vermelho.png',
  'icon_colheita_afericao_branco.png',
  'icon_doenca_amarelo.png',
  'icon_doenca_azul.png',
  'icon_doenca_branco.png',
  'icon_doenca_roxo.png',
  'icon_doenca_verde.png',
  'icon_doenca_vermelho.png',
  'icon_generico_branco.png',
  'icon_inimigo_natural_amarelo.png',
  'icon_inimigo_natural_branco.png',
  'icon_inimigo_natural_verde.png',
  'icon_inimigo_natural_vermelho.png',
  'icon_inseto_amarelo.png',
  'icon_inseto_azul.png',
  'icon_inseto_branco.png',
  'icon_inseto_roxo.png',
  'icon_inseto_verde.png',
  'icon_inseto_vermelho.png',
  'icon_invasora_amarelo.png',
  'icon_invasora_azul.png',
  'icon_invasora_branco.png',
  'icon_invasora_roxo.png',
  'icon_invasora_verde.png',
  'icon_invasora_vermelho.png',
  'icon_manutencao_melhoria_amarelo.png',
  'icon_manutencao_melhoria_branco.png',
  'icon_manutencao_melhoria_verde.png',
  'icon_manutencao_melhoria_vermelho.png',
  'icon_massa_seca_pastagem_amarelo.png',
  'icon_nematoide_amarelo.png',
  'icon_nematoide_azul.png',
  'icon_nematoide_branco.png',
  'icon_nematoide_roxo.png',
  'icon_nematoide_verde.png',
  'icon_nematoide_vermelho.png',
  'icon_produtividade_amarelo.png',
  'icon_produtividade_branco.png',
  'icon_produtividade_verde.png',
  'icon_produtividade_vermelho.png',
  'icon_recomendacao_amarelo.png',
  'icon_recomendacao_branco.png',
  'icon_recomendacao_verde.png',
  'icon_recomendacao_vermelho.png',
  'icon_semeadura_afericao_branco.png',
  'icon_solo_amarelo.png',
  'icon_solo_branco.png',
  'icon_solo_verde.png',
  'icon_solo_vermelho.png',
  'icon_stand_amarelo.png',
  'icon_stand_branco.png',
  'icon_stand_verde.png',
  'icon_stand_vermelho.png',
  'icon_tarefa_amarelo.png',
  'icon_tarefa_concluida.png',
  'icon_visita_amarelo.png',
  'icon_visita_verde.png',
  'icon_visita_vermelho.png',
];

// Jest (jsdom) não implementa `require.context`, feature exclusiva do webpack.
const criarContextoDeTeste = (): ContextoWebpack => {
  const contextoFn = ((chave: string) => `./${chave}`) as ContextoWebpack;

  contextoFn.keys = () => NOMES_ICONES_TESTE.map((nome) => `./${nome}`);

  return contextoFn;
};

const contexto: ContextoWebpack =
  process.env.NODE_ENV === 'test'
    ? criarContextoDeTeste()
    : (
        require as unknown as {
          context: (
            dir: string,
            recursivo: boolean,
            filtro: RegExp,
          ) => ContextoWebpack;
        }
      ).context('../../../../assets/marker-icons', false, /icon_.*\.png$/);

const ICONES: Record<string, string> = contexto.keys().reduce(
  (acumulado, chave) => {
    const nome = chave
      .replace(/^\.\//, '')
      .replace(/^icon_/, '')
      .replace(/\.png$/, '');
    const modulo = contexto(chave);

    acumulado[nome] = typeof modulo === 'string' ? modulo : modulo.default;

    return acumulado;
  },
  {} as Record<string, string>,
);

const corDaSituacao = (marcador?: RelatorioVisitaMarcador): string => {
  const situacao = marcador?.situacao || marcador?.classificacao || '';

  return CORES_POR_SITUACAO[situacao] ?? 'verde';
};

const iconeDoMarcador = (marcador?: RelatorioVisitaMarcador): string | null => {
  const tipo = marcador?.tipo ?? 'generico';

  const cor = corDaSituacao(marcador);

  return (
    ICONES[`${tipo}_${cor}`] ??
    ICONES[`${tipo}_branco`] ??
    ICONES[`${tipo}_amarelo`] ??
    ICONES.generico_branco ??
    null
  );
};

export default iconeDoMarcador;
